// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file transport.proto (package replit.river.internal.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transport.proto.
 */
export const file_transport: GenFile = /*@__PURE__*/
  fileDesc("Cg90cmFuc3BvcnQucHJvdG8SGHJlcGxpdC5yaXZlci5pbnRlcm5hbC52MSI9ChJQcm9wYWdhdGlvbkNvbnRleHQSEwoLdHJhY2VwYXJlbnQYASABKAkSEgoKdHJhY2VzdGF0ZRgCIAEoCSKuAgoRVHJhbnNwb3J0RW52ZWxvcGUSCgoCaWQYASABKAkSDAoEZnJvbRgCIAEoCRIKCgJ0bxgDIAEoCRILCgNzZXEYBCABKA0SCwoDYWNrGAUgASgNEhEKCXN0cmVhbV9pZBgGIAEoCRIVCg1jb250cm9sX2ZsYWdzGAcgASgNEhQKDHNlcnZpY2VfbmFtZRgIIAEoCRIWCg5wcm9jZWR1cmVfbmFtZRgJIAEoCRI9Cgd0cmFjaW5nGAogASgLMiwucmVwbGl0LnJpdmVyLmludGVybmFsLnYxLlByb3BhZ2F0aW9uQ29udGV4dBIXCg1wYXlsb2FkX2J5dGVzGAsgASgMSAASGQoPcGF5bG9hZF9tc2dwYWNrGAwgASgMSABCDgoMcGF5bG9hZF9raW5kYgZwcm90bzM");

/**
 * *
 * OpenTelemetry propagation context forwarded between peers.
 *
 * @generated from message replit.river.internal.v1.PropagationContext
 */
export type PropagationContext = Message<"replit.river.internal.v1.PropagationContext"> & {
  /**
   * @generated from field: string traceparent = 1;
   */
  traceparent: string;

  /**
   * @generated from field: string tracestate = 2;
   */
  tracestate: string;
};

/**
 * Describes the message replit.river.internal.v1.PropagationContext.
 * Use `create(PropagationContextSchema)` to create a new message.
 */
export const PropagationContextSchema: GenMessage<PropagationContext> = /*@__PURE__*/
  messageDesc(file_transport, 0);

/**
 * *
 * Internal protobuf envelope used by the proto codec to carry River transport
 * messages.
 *
 * @generated from message replit.river.internal.v1.TransportEnvelope
 */
export type TransportEnvelope = Message<"replit.river.internal.v1.TransportEnvelope"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string from = 2;
   */
  from: string;

  /**
   * @generated from field: string to = 3;
   */
  to: string;

  /**
   * @generated from field: uint32 seq = 4;
   */
  seq: number;

  /**
   * @generated from field: uint32 ack = 5;
   */
  ack: number;

  /**
   * @generated from field: string stream_id = 6;
   */
  streamId: string;

  /**
   * @generated from field: uint32 control_flags = 7;
   */
  controlFlags: number;

  /**
   * @generated from field: string service_name = 8;
   */
  serviceName: string;

  /**
   * @generated from field: string procedure_name = 9;
   */
  procedureName: string;

  /**
   * @generated from field: replit.river.internal.v1.PropagationContext tracing = 10;
   */
  tracing?: PropagationContext;

  /**
   * @generated from oneof replit.river.internal.v1.TransportEnvelope.payload_kind
   */
  payloadKind: {
    /**
     * @generated from field: bytes payload_bytes = 11;
     */
    value: Uint8Array;
    case: "payloadBytes";
  } | {
    /**
     * @generated from field: bytes payload_msgpack = 12;
     */
    value: Uint8Array;
    case: "payloadMsgpack";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message replit.river.internal.v1.TransportEnvelope.
 * Use `create(TransportEnvelopeSchema)` to create a new message.
 */
export const TransportEnvelopeSchema: GenMessage<TransportEnvelope> = /*@__PURE__*/
  messageDesc(file_transport, 1);

